import React from 'react';

export const YoutubeIcon = () => {
  return (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.1"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.800781 16C0.800781 7.16344 7.96423 0 16.8008 0C25.6373 0 32.8008 7.16344 32.8008 16C32.8008 24.8366 25.6373 32 16.8008 32C7.96423 32 0.800781 24.8366 0.800781 16Z"
        fill="#F0F0F0"
      />
      <path
        d="M24.1782 12.2884C24.0905 11.9619 23.9187 11.6641 23.6798 11.425C23.4409 11.1858 23.1433 11.0135 22.8169 10.9254C21.6155 10.6023 16.7996 10.6023 16.7996 10.6023C16.7996 10.6023 11.9837 10.6023 10.7823 10.9237C10.4557 11.0115 10.1581 11.1837 9.91912 11.4229C9.68018 11.6621 9.5084 11.96 9.42102 12.2867C9.09961 13.4898 9.09961 15.9992 9.09961 15.9992C9.09961 15.9992 9.09961 18.5085 9.42102 19.71C9.59805 20.3734 10.1205 20.8959 10.7823 21.0729C11.9837 21.396 16.7996 21.396 16.7996 21.396C16.7996 21.396 21.6155 21.396 22.8169 21.0729C23.4804 20.8959 24.0012 20.3734 24.1782 19.71C24.4996 18.5085 24.4996 15.9992 24.4996 15.9992C24.4996 15.9992 24.4996 13.4898 24.1782 12.2884ZM15.2699 18.3023V13.696L19.2574 15.982L15.2699 18.3023Z"
        fill="#F0F0F0"
      />
    </svg>
  );
};
